import { BaseShader } from "webgl-framework";
import { ShaderInputs } from "./ShaderInputs";
import { engine } from "../KotlinLib";

/**
 * Test shader which visualizes mesh normals.
 *
 * The normal is used exactly as it is stored in the vertex buffer: it is NOT
 * transformed (neither by the model matrix nor by any normal matrix) and NOT
 * remapped, negated or renormalized. It is written straight to the color
 * output, so components in [-1, 0] clamp to 0 and only positive ones show:
 * +X is red, +Y is green, +Z is blue.
 *
 * Only vertex positions are transformed, by the MVP matrix, so the geometry
 * stays where it belongs. Uniforms: [view_proj_matrix].
 */
export class TestModelNormalsShader extends BaseShader implements ShaderInputs {
    view_proj_matrix: WebGLUniformLocation | undefined;
    rm_Vertex: number | undefined;
    rm_Normal: number | undefined;

    public attributes?: number[];
    public typedAttributes?: { [key: number]: number };
    public uniforms?: WebGLUniformLocation[];

    /** @inheritdoc */
    fillCode() {
        this.vertexShaderCode = `precision highp float;
            uniform mat4 view_proj_matrix;
            attribute vec4 rm_Vertex;
            attribute vec3 rm_Normal;
            varying vec3 vNormal;

            void main() {
              gl_Position = view_proj_matrix * rm_Vertex;
              vNormal = rm_Normal;
            }`;

        this.fragmentShaderCode = `precision mediump float;
            varying vec3 vNormal;

            void main() {
              gl_FragColor = vec4(vNormal, 1.0);
            }`;
    }

    /** @inheritdoc */
    fillUniformsAttributes() {
        this.rm_Vertex = this.getAttrib("rm_Vertex");
        this.rm_Normal = this.getAttrib("rm_Normal");

        this.view_proj_matrix = this.getUniform("view_proj_matrix");

        this.attributes = [this.rm_Vertex, this.rm_Normal];
        this.typedAttributes = {
            [engine.AttributeType.VERTEX.ordinal]: this.rm_Vertex!,
            [engine.AttributeType.NORMAL.ordinal]: this.rm_Normal!
        };
        this.uniforms = [this.view_proj_matrix];
    }
}
